// src/data/testSeriesData.js

// --- PrrepX Pathshala: Premium Test Series Catalog (IIT-JEE & NEET) ---
// Note: All series include 1-year access from the date of purchase.

export const jeePremiumSeries = [
    {
        id: 'jee_c11_chap',
        title: "JEE Class 11th: Chapterwise Test",
        subtitle: "Build your foundation with 36 targeted chapter tests designed by IIT alumni. Perfect your concepts with focused 60-minute sessions covering Physics, Chemistry & Mathematics.",
        price: "₹199", oldPrice: "₹4999",
        ValidityYears: 1,
        NumberOfTests: 36,          // Total number of tests
        TestTime: 60,               // Duration in minutes per test
        Questions: 45,              // Questions per test
        benefits: [
            "Risk-Free: 30-day no-questions-asked refund policy",
            "Subject Mastery: Targeted tests for Physics, Chemistry, and Math",
            "Extensive Practice: 30–36 specialized chapter-level assessments",
            "Foundation Building: Designed to strengthen core problem-solving logic",
            "Target Audience: Ideal for Class 11 students aiming for JEE 2027/28",
            "Format: 60-minute focused sessions",
            "Access: Full 1-year validity, but 2 Years Validity if Booked via Combo Pack",
        ],
        link: "/test-series/jee-premium/jee_c11_chap",
    },
    {
        id: 'jee_c12_chap',
        title: "JEE Class 12th: Chapterwise Test",
        subtitle: "Master Class 12 with 36 precision-engineered chapter tests curated by top rankers. Sharpen your speed and accuracy with high-yield questions aligned to latest JEE patterns.",
        price: "₹199", oldPrice: "₹4999",
        ValidityYears: 1,
        NumberOfTests: 36,          // Total number of tests
        TestTime: 60,               // Duration in minutes per test
        Questions: 45,              // Questions per test
        benefits: [
            "Risk-Free: 30-day no-questions-asked refund policy",
            "Precision Training: In-depth Subject-wise (PCM) chapter tests",
            "Curated Questions: 30–36 high-yield tests for board & entrance alignment",
            "Accuracy Boost: Focused on eliminating negative marking and improving speed",
            "Target Audience: Essential for Class 12 students and aspirants",
            "Format: 60-minute focused sessions",
            "Access: Full 1-year validity, but 2 Years Validity if Booked via Combo Pack",
        ],
        link: "/test-series/jee-premium/jee_c12_chap",
    },
    {
        id: 'jee_c11_full',
        title: "JEE Class 11th: Full-Syllabus Test",
        subtitle: "Experience real exam pressure with 10 comprehensive 3-hour mock tests covering complete Class 11 syllabus. Build stamina and strategy for JEE Main with full-length simulations crafted by IIT experts.",
        price: "₹199", oldPrice: "₹3999",
        ValidityYears: 1,
        NumberOfTests: 10,          // Total number of tests
        TestTime: 180,              // Duration in minutes per test
        Questions: 75,              // Questions per test
        benefits: [
            "Risk-Free: 30-day no-questions-asked refund policy",
            "Full Simulation: 10 comprehensive full-length PCM mock exams",
            "Syllabus Alignment: 100% compliant with the latest JEE Class 11 pattern",
            "Exam Readiness: Experience the real IIT-JEE testing environment",
            "Strategic Practice: Matches JEE Main difficulty and question distribution",
            "Format: 3-hour standardized exam duration",
            "Access: Full 1-year validity",
        ],
        link: "/test-series/jee-premium/jee_c11_full",
    },
    {
        id: 'jee_c12_full',
        title: "JEE Class 12th: Full-Syllabus Test",
        subtitle: "Ace your boards and JEE together with 10 rigorous full-length tests covering Class 12 PCM syllabus. Perfect for final-year students and droppers aiming for top ranks with NTA-pattern mock exams.",
        price: "₹199", oldPrice: "₹3999",
        ValidityYears: 1,
        NumberOfTests: 10,          // Total number of tests
        TestTime: 180,              // Duration in minutes per test
        Questions: 75,              // Questions per test
        benefits: [
            "Risk-Free: 30-day no-questions-asked refund policy",
            "Final Prep: 10 high-impact full-length PCM mock exams",
            "Syllabus Alignment: 100% compliant with the latest JEE Class 12 pattern",
            "Performance Benchmarking: Accurate simulation of the actual JEE atmosphere",
            "Target Audience: Designed for Class 12 students and Droppers",
            "Format: 3-hour standardized exam duration",
            "Access: Full 1-year validity",
        ],
        link: "/test-series/jee-premium/jee_c12_full",
    },
    {
        id: 'jee_11_12_full',
        title: "JEE Full Length Test Series",
        subtitle: "Ultimate JEE preparation with 12 complete mock tests integrating Class 11 & 12 syllabus in one series. Your final weapon for JEE Main & Advanced success with comprehensive coverage and detailed analytics.",
        price: "₹199", oldPrice: "₹3999",
        ValidityYears: 1,
        NumberOfTests: 12,          // Total number of tests
        TestTime: 180,              // Duration in minutes per test
        Questions: 90,              // Questions per test
        benefits: [
            "Risk-Free: 30-day no-questions-asked refund policy",
            "The Complete Package: 12 comprehensive full-length mock tests",
            "Holistic Coverage: Integrated Class 11 & 12 syllabus simulation",
            "Advanced Analytics: Closest possible match to JEE Main & Advanced patterns",
            "Exam Strategy: Perfect for final revision and timing management",
            "Format: 3-hour standardized exam duration",
            "Access: Full 1-year validity, but 2 Years Validity if Booked via Combo Pack",
        ],
        link: "/test-series/jee-premium/jee_11_12_full",
    },
    {
        id: 'jee_aits',
        title: "AITS: All India Test Series for IIT-JEE",
        subtitle: "Compete with 50,000+ JEE aspirants nationwide through 27 challenging tests with instant All India Rank. Get real-time percentile, detailed analytics and benchmark your preparation against the best minds in India.",
        price: "₹199", oldPrice: "₹4999",
        ValidityYears: 1,
        NumberOfTests: 27,          // Total number of tests
        TestTime: 120,              // Duration in minutes per test (average)
        Questions: 60,              // Questions per test (average)
        benefits: [
            "Risk-Free: 30-day no-questions-asked refund policy",
            "National Competition: Benchmark your performance against students nationwide",
            "Diverse Assessment: 15 Chapter-wise, 6 Mixed-Topic, and 6 Full-Length tests",
            "Real-Time Insights: Instant All India Rank (AIR), percentile, and deep analytics",
            "Elite Standard: Matches the complexity of JEE Main & Advanced",
            "Format: Adaptive testing durations",
            "Access: Full 1-year validity",
        ],
        link: "/test-series/jee-premium/jee_aits",
    },
];

export const neetPremiumSeries = [
    {
        id: 'neet_c11_chap',
        title: "NEET Class 11th: Chapter-wise Test",
        subtitle: "Master NCERT concepts with 36 focused chapter tests designed by medical college alumni. Build unshakable fundamentals in Physics, Chemistry & Biology with 60-minute targeted practice sessions.",
        price: "₹199", oldPrice: "₹4999",
        ValidityYears: 1,
        NumberOfTests: 36,          // Total number of tests
        TestTime: 60,               // Duration in minutes per test
        Questions: 45,              // Questions per test
        benefits: [
            "Risk-Free: 30-day no-questions-asked refund policy",
            "Concept Clarity: Subject-wise (PCB) tests focused on NCERT fundamentals",
            "Extensive Practice: 30–36 specialized chapter-level assessments",
            "Confidence Builder: Designed to master individual biological and physical concepts",
            "Target Audience: Essential for Class 11 medical aspirants",
            "Format: 60-minute focused sessions",
            "Access: Full 1-year validity, but 2 Years Validity if Booked via Combo Pack",
        ],
        link: "/test-series/neet-premium/neet_c11_chap",
    },
    {
        id: 'neet_c12_chap',
        title: "NEET Class 12th: Chapter-wise Test",
        subtitle: "Dominate Class 12 boards and NEET with 36 high-yield chapter tests covering all PCB topics. Perfect your speed, accuracy and factual recall with NCERT-centric questions crafted by top medical rankers.",
        price: "₹199", oldPrice: "₹4999",
        ValidityYears: 1,
        NumberOfTests: 36,          // Total number of tests
        TestTime: 60,               // Duration in minutes per test
        Questions: 45,              // Questions per test
        benefits: [
            "Risk-Free: 30-day no-questions-asked refund policy",
            "NCERT Centric: In-depth Biology, Physics, and Chemistry chapter tests",
            "High-Yield Questions: 30–36 tests focused on high-weightage NEET topics",
            "Retention Focus: Designed to improve recall speed and factual accuracy",
            "Target Audience: Ideal for Class 12 NEET candidates",
            "Format: 60-minute focused sessions",
            "Access: Full 1-year validity, but 2 Years Validity if Booked via Combo Pack",
        ],
        link: "/test-series/neet-premium/neet_c12_chap",
    },
    {
        id: 'neet_c11_full',
        title: "NEET Class 11th: Full-Syllabus Test",
        subtitle: "Experience real NEET pressure early with 10 comprehensive 200-minute mock tests covering complete Class 11 PCB syllabus. Build exam temperament and time management skills with NTA-pattern full-length simulations.",
        price: "₹199", oldPrice: "₹3999",
        ValidityYears: 1,
        NumberOfTests: 10,          // Total number of tests
        TestTime: 200,              // Duration in minutes per test
        Questions: 180,             // Questions per test
        benefits: [
            "Risk-Free: 30-day no-questions-asked refund policy",
            "Exam Mastery: 10 full-length PCB tests covering the Class 11 syllabus",
            "Pattern-Ready: Follows the latest NTA NEET exam guidelines",
            "Simulation: Mimics the real-world pressure of the medical entrance exam",
            "Target Audience: Tailored for Class 11 students for early readiness",
            "Format: 200-minute standardized exam duration",
            "Access: Full 1-year validity",
        ],
        link: "/test-series/neet-premium/neet_c11_full",
    },
    {
        id: 'neet_c12_full',
        title: "NEET Class 12th: Full-Syllabus Test",
        subtitle: "Your final lap to medical college with 10 rigorous full-length tests covering Class 12 PCB syllabus completely. Essential for Class 12 students and droppers with 100% NCERT alignment and NTA difficulty level.",
        price: "₹199", oldPrice: "₹3999",
        ValidityYears: 1,
        NumberOfTests: 10,          // Total number of tests
        TestTime: 200,              // Duration in minutes per test
        Questions: 180,             // Questions per test
        benefits: [
            "Risk-Free: 30-day no-questions-asked refund policy",
            "Intensive Prep: 10 high-quality full-length PCB mock exams",
            "Syllabus Mastery: 100% alignment with Class 12 NCERT & NEET standards",
            "Strategic Advantage: Expert-level simulation to boost score potential",
            "Target Audience: Critical for Class 12 students and Droppers",
            "Format: 200-minute standardized exam duration",
            "Access: Full 1-year validity",
        ],
        link: "/test-series/neet-premium/neet_c12_full",
    },
    {
        id: 'neet_11_12_full',
        title: "NEET Full Length Test Series",
        subtitle: "Complete NEET mastery with 12 full-length mock tests integrating entire Class 11 & 12 PCB syllabus in one powerful series. Your ultimate preparation tool with detailed performance tracking and comprehensive NCERT coverage.",
        price: "₹199", oldPrice: "₹3999",
        ValidityYears: 1,
        NumberOfTests: 12,          // Total number of tests
        TestTime: 200,              // Duration in minutes per test
        Questions: 200,             // Questions per test
        benefits: [
            "Risk-Free: 30-day no-questions-asked refund policy",
            "Full-Scale Testing: 12 comprehensive 3-hour mock exams",
            "Complete NCERT Coverage: Integrated Class 11 & 12 PCB syllabus",
            "Detailed Feedback: In-depth performance tracking and error analysis",
            "Target Audience: The gold standard for Class 12 and Dropper students",
            "Access: Full 1-year validity, but 2 Years Validity if Booked via Combo Pack",
        ],
        link: "/test-series/neet-premium/neet_11_12_full",
    },
    {
        id: 'neet_aits',
        title: "AITS: All India Test Series for NEET",
        subtitle: "Challenge yourself against 50,000+ medical aspirants with 27 competitive tests featuring instant All India Rank and percentile. Get real-time performance analytics and identify your strengths across India's premier NEET testing platform.",
        price: "₹199", oldPrice: "₹4999",
        ValidityYears: 1,
        NumberOfTests: 27,          // Total number of tests
        TestTime: 150,              // Duration in minutes per test (average)
        Questions: 180,             // Questions per test (average)
        benefits: [
            "Risk-Free: 30-day no-questions-asked refund policy",
            "National Benchmark: Compete on India's premier NEET testing platform",
            "Comprehensive Curriculum: 15 Chapter-wise, 6 Mixed, and 6 Full-Length tests",
            "Competitive Edge: Real-time AIR, percentile, and comparative analytics",
            "NTA Standard: Strictly based on the latest NEET difficulty levels",
            "Access: Full 1-year validity, but 2 Years Validity if Booked via Combo Pack",
        ],
        link: "/test-series/neet-premium/neet_aits",
    },
];

export const jeeUltimateCombo = [
    {
        id: 'jee_ultimate_combo',
        title: "JEE 3-in-1 Combo Pack",
        subtitle: "Complete JEE domination with 84 tests combining Class 11 chapter-wise, Class 12 chapter-wise, and full syllabus series in one mega pack. Save 95% with 2-year validity - the smartest choice for serious JEE aspirants and droppers.",
        price: "499", oldPrice: "₹9999",
        ValidityYears: 2,
        NumberOfTests: 84,          // Total number of tests (all included)
        TestTime: 0,                // Not applicable (mixed tests)
        Questions: 0,               // Not applicable (mixed tests)
        benefits: [
            "Includes JEE Class 11th Chapter-wise series",
            "Includes JEE Class 12th Chapter-wise series",
            "Includes JEE Full-Syllabus Combined Class 11+12th Test Series",
            "Maximum Value: Save over 90% compared to individual purchases",
            "Target Audience: The preferred choice for Droppers and serious aspirants",
            "Extended Access: 2-Year Validity for long-term preparation",
        ],
        link: "/test-series/jee-premium/jee_ultimate_combo",
        Contains_ids: ['jee_c11_chap', 'jee_c12_chap', 'jee_11_12_full'],
    },
];

export const neetUltimatePremium = [
    {
        id: 'neet_ultimate_combo',
        title: "NEET 3-in-1 Combo Pack",
        subtitle: "Your complete roadmap to medical college with 84 tests covering Class 11 chapters, Class 12 chapters, and full syllabus tests in one ultimate package. Unbeatable value with 2-year access - perfect for multi-year planning and guaranteed success.",
        price: "499", oldPrice: "₹9999",
        ValidityYears: 2,
        NumberOfTests: 84,          // Total number of tests (all included)
        TestTime: 0,                // Not applicable (mixed tests)
        Questions: 0,               // Not applicable (mixed tests)
        benefits: [
            "Includes NEET Class 11th Chapter-wise series",
            "Includes NEET Class 12th Chapter-wise series",
            "Includes NEET Full-Syllabus Combined Class 11+12th Test Series",
            "Unbeatable Savings: Premium medical prep at the lowest market price",
            "Target Audience: Perfect for multi-year planning and Droppers",
            "Extended Access: 2-Year Validity for long-term preparation",
        ],
        link: "/test-series/neet-premium/neet_ultimate_combo",
        Contains_ids: ['neet_c11_chap', 'neet_c12_chap', 'neet_11_12_full'],
    },
];

export const freeSeries = [
    {
        title: "NEET: Previous Year Questions(PYQ) Test Series",
        price: "Free", oldPrice: null,
        benefits: [
            "Proven Practice: Real past NEET papers converted into timed tests",
            "Extensive Collection: 24 full-length authentic past papers",
            "Performance Insight: Instant results with detailed performance reports",
            "Authenticity: The most reliable way to gauge your current exam readiness",
            "Accessibility: 100% free forever for all students",
            "Access: Lifetime Validity",
        ],
        link: "/test-series/pyq/neet",
    },
    {
        title: "JEE Main: Previous Year Questions (PYQ) Series",
        price: "Free", oldPrice: null,
        benefits: [
            "Authentic Experience: Solve actual past JEE Main papers in a timed format",
            "Library: 24 high-quality Previous Year Tests available instantly",
            "Modern Interface: Experience the NTA-style Computer Based Test (CBT) environment",
            "Instant Grading: Receive immediate scores and topic-wise analysis",
            "Accessibility: 100% free forever for all students",
            "Access: Lifetime Validity",
        ],
        link: "/test-series/pyq/jeemains",
    },
    {
        title: "JEE Advanced: Previous Year Questions (PYQ) Series",
        price: "Free", oldPrice: null,
        benefits: [
            "Elite Practice: Real past JEE Advanced papers in a digital format",
            "Massive Archive: Access over 40 Previous Year Tests",
            "Complex Simulation: Experience the challenging multi-format marking schemes",
            "Deep Analysis: Identify gaps in high-level conceptual application",
            "Accessibility: 100% free forever for all students",
            "Access: Lifetime Validity",
        ],
        link: "/test-series/pyq/jeeadv",
    },
    
];

// --- Data Utilities ---

export const getTrackableSeries = () => [
    ...jeePremiumSeries.map(s => ({ id: s.id, title: s.title })),
    ...neetPremiumSeries.map(s => ({ id: s.id, title: s.title })),
    ...jeeUltimateCombo.map(s => ({ id: s.id, title: s.title })),
    ...neetUltimatePremium.map(s => ({ id: s.id, title: s.title })),
];

export const getAllSeries = () => [
    ...jeePremiumSeries,
    ...neetPremiumSeries,
    ...jeeUltimateCombo,
    ...neetUltimatePremium,
    ...freeSeries.map(s => ({ ...s, id: s.link.split('/').pop() })) 
];

export const findSeriesById = (id) => {
    return getAllSeries().find(series => series.id === id);
};